
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    MultiSelectBt: () => import("../Common/MultiSelectBt.vue"),
  },
})
export default class ModalMobileSearch extends Vue {
  isUniSearch = false;
  search = "";
  optSearch = [
    {
      section: "Puesto",
      info: [
        { name: "Ejecutiva de cuentas", category: "ejecutiva" },
        { name: "Ejecutiva de ventas", category: "ejecutiva" },
        { name: "Secretaria ejecutiva", category: "ejecutiva" },
        { name: "Asistente ejecutiva", category: "ejecutiva" },
      ],
    },
    {
      section: "Área",
      info: [
        { name: "Recursos Humanos", category: "rrhh" },
        { name: "Gerencia", category: "gerencia" },
      ],
    },
  ];
  value = "";
  options = [
    "Select option",
    "Buenos Aires, Argentina",
    "Santa Fe, Argentina",
    "Mendoza, Argentina",
    "Córdoba, Argentina",
  ];

  @Watch("isUniSearch")
  onChangeIsUniSearch(val: string) {
    if (status) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }

  reloadPage() {
    window.location.reload();
  }

  show() {
    this.isUniSearch = true;
  }

  hide() {
    this.isUniSearch = false;
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }
}
